<template>
<div id="covid_usa_totals_table" class="covid_totals_table">
    <div class="widget_container" :class="{'wide': wide}">
        <div v-if="info_open" class="info_window">
            <span class="close" @click="info_open = false">X</span>
            <covid-info :wide="wide" type="usa"></covid-info>
        </div>
        <div v-if="showHeader" class="red_header"><a :href="landing_page_url+query_parameters" :target="landing_page_target" >Novel Coronavirus (COVID-19) USA Fatalities</a></div>
        <div v-if="loading" class="loading"><img src="/images/loading_24w.gif" alt="Loading" /></div>
        <div v-else class="data_table">
            <table class="data large" :class="{'wide': wide}">
                <thead>
                <tr class="header">
                    <th class="state_name" @click="table_sort('name', 'string')" :class="current_sort('name')">State</th>
                    <!--<th class="deaths_previous_day" v-if="wide" @click="table_sort('deaths_previous_day')" :class="current_sort('deaths_previous_day')">Previous Day<br>Deaths</th>-->
                    <th @click="table_sort('deaths_pm')" :class="current_sort('deaths_pm')">Deaths /<br>1M <span class="deaths-pop-text" >pop</span></th>
                    <th v-if="wide" class="estimated_cases" @click="table_sort('estimated_cases')" :class="current_sort('estimated_cases')">Total<br>Cases</th>
                    <th v-if="!wide && !isIframe" 
                        class="estimated_cases" @click="table_sort('estimated_cases')" 
                        :class="current_sort('estimated_cases')">Total<br>Cases</th>
                    <th v-if="!wide && isIframe" class="new_deaths" @click="table_sort('new_deaths')" :class="current_sort('new_deaths')">New <br>Deaths</th>
                    <th class="confirmed" @click="table_sort('confirmed')" :class="current_sort('confirmed')">Confirmed<br>Cases</th>
                    <th v-if="!wide" 
                        class="deaths_p_cases above_phone_portrait" @click="table_sort('deaths_p_cases')" 
                        :class="current_sort('deaths_p_cases')">Confirmed Case<br>Fatality Rate</th>
                    <th v-if="wide" @click="table_sort('deaths_p_cases')" :class="current_sort('deaths_p_cases')">Confirmed Case<br>Fatality Rate</th>
                    <th v-if="wide" >Total Case<br>Fatality Rate</th>
                    <!--<th class="estimated_cases above_phone_portrait" @click="table_sort('actual_fatality_rate')" :class="current_sort('actual_fatality_rate')">Actual<br>Fatality Rate</th>-->
                    <th class="tests" @click="table_sort('tests')" :class="current_sort('tests')">Tests</th>
                    <th @click="table_sort('tests_pm')" :class="current_sort('tests_pm')">Tests /<br>1M <span class="deaths-pop-text" >pop</span></th>
                    <!--<th class="critical" @click="table_sort('critical')" :class="current_sort('critical')">Serious,<br>Critical</th>-->
                    <!--<th v-if="wide" @click="table_sort('critical_pm')" :class="current_sort('critical_pm')">Critical /<br>1M <span class="deaths-pop-text" >pop</span></th>-->
                    <th v-if="!wide && !isIframe" class="estimated_cases above_phone_portrait" @click="table_sort('estimated_cases')" :class="current_sort('estimated_cases')">Total<br>Cases</th>
                    <th v-if="wide" class="confirmed_pm" @click="table_sort('confirmed_pm')" :class="current_sort('confirmed_pm')">Confirmed Cases /<br>1M <span class="deaths-pop-text" >pop</span></th>
                    <!--<th @click="table_sort('h1n1')" :class="current_sort('h1n1')">H1N1 Swine<br>Flu Deaths *</th>-->
                    <!--<th v-if="!wide" class="phone_portrait" @click="table_sort('deaths_p_cases')" :class="current_sort('deaths_p_cases')">Confirmed Case<br>Fatality Rate</th>-->
                    <th v-if="wide" class="new_deaths" @click="table_sort('new_deaths')" :class="current_sort('new_deaths')">New <br>Deaths</th>
                    <th class="deaths" @click="table_sort('deaths')" :class="current_sort('deaths')">Deaths</th>
                    <!--<th v-if="!wide" class="above_phone_portrait" @click="table_sort('influenza_deaths_v2')" :class="current_sort('influenza_deaths_v2')">Seasonal <br v-if="!wide">Flu Deaths<sup>1</sup><br v-if="wide"><span v-if="wide">(CDC 10-Year Avg)</span></th>
                    <th v-if="wide" @click="table_sort('influenza_deaths_v2')" :class="current_sort('influenza_deaths_v2')">Seasonal <br v-if="!wide">Flu Deaths<sup>1</sup><br v-if="wide"><span v-if="wide">(CDC 10-Year Avg)</span>
                </th>-->
            </tr>
                </thead>
                <tbody v-if="wide" id="global" class="gray-landing-heading" >
                    <tr class="global">
                        <td class="state_name above_phone_portrait" ></td>
                        <td class="country_name phone_portrait" >Deaths</td>
                        <td class="deaths" v-html="number_format_wrapper_total(table_data.country_total.deaths_total)"></td>
                        <!--<td v-if="wide" class="deaths_previous_day">-</td>-->
                        <!--<td>-</td>-->
                        <td>-</td><!-- Total Cases Sub Heading -->
                        <td>-</td><!-- Confirmed Cases Sub Heading -->
                        <td>-</td><!-- COnfirmed Case Fatality Rate Sub Heading -->
                        <td>-</td><!-- Total Case Fatality Rate Fatality Rate Sub Heading -->
                        <!--<td class="critical">-</td>-->
                        <!--<td v-if="wide" v-html="number_format_wrapper(table_data.country_total.critical_pm)"></td>-->
                        <!--<td v-if="!wide" class="estimated_cases above_phone_portrait">-</td>-->
                        <td v-html="number_format_wrapper_total(table_data.country_total.confirmed_total)"></td>
                        <td class="above_phone_portrait estimated_cases">-</td>
                        <!--<td v-if="wide" v-html="number_format(table_data.country_total.deaths_p_cases, 2)+\'%\'"></td>-->
                        <td>-</td>
                        <td v-if="wide">-</td>
                        <!--<td v-html="number_format_wrapper_total(table_data.country_total.h1n1)"></td>-->
                        <!--<td v-if="!wide" class="deaths_p_cases" v-html="number_format(table_data.country_total.deaths_p_cases, 2)+\'%\'"></td>-->
                        <!--<td v-if="!wide" class="influenza_deaths_v2 above_phone_portrait">-</td>
                        <td v-if="wide" class="influenza_deaths_v2">-</td>-->
                    </tr>
                </tbody>
                <tbody id="per-country" >
                    <template v-for="(state, index) in table_data.state_data"  >
                        <state-row 
                            :key="state.id"
                            v-if="( ( limit == 0 && should_display_state(state.name) ) || index < limit)"
                            :state="state"
                            :wide="wide"
                            :is-iframe="isIframe"
                        >
                        </state-row>
                    </template>
                </tbody>
                <tfoot>
                    <tr v-if="!wide" class="bottom_link" :class="{'alt': footer_alt(0)}">
                        <td :colspan="full_table_colspan()">
                            <a :href="landing_page_url+query_parameters" :target="landing_page_target" >Full State List of Coronavirus Fatalities</a> <span class="info" @click="info_open = true">&#x1F6C8;</span>
                        </td>
                    </tr>
                    <template v-else>
                        <tr class="bottom_info">
                            <td :colspan="full_table_colspan()"><covid-info :wide="wide" type="usa"></covid-info></td>
                        </tr>
                    </template>
                </tfoot>
            </table>
        </div>
    </div>
</div>
</template>

<script>

const StateRow = () => import(/* webpackChunkName: "CovidStateRow" */ "./StateRow.vue");
const CovidInfo = () => import(/* webpackChunkName: "CovidCovidInfo" */ "./CovidInfo.vue");

import CovidMixin from './CovidMixin.js';

export default {
    name: 'covid-usa-totals-table',
    components: {
        'state-row': StateRow,
        'covid-info': CovidInfo,
    },
    mixins: [
        CovidMixin,
    ],
    props: {
        showHeader: {
            type: Boolean,
            default: true,
        },
        limit: {
            type: Number,
            default: 0
        },
        wide: {
            type: Boolean,
            default: false,
        },
        isIframe: {
            type: Boolean,
            default: false,
        },
        whitelist: {
            type: Array,
            default: function() {
                return [];
            },
        },
    },
    data : function() {
        return {
            loading: true,
            info_open: false,
            cache_bust : Math.floor((new Date()).getTime() / 25000), // Changes every 25 seconds
            table_data : {},
            promises : [],
            sort_col : '',
            sort_type : '',
            alt_state_names : {
                "USA" : "United States",
                "S. Korea" : "South Korea",
                "UK" : "United Kingdom",
                "China" : "China*",
                "District Of Columbia" : "District of Columbia",
            },
            landing_page_url: '/coronavirus/country/united-states/',
        };
    },
    created : function() {
        this.load_json();
    },
    computed: {

        landing_page_target: function(){

            if(this.isIframe){
                return '_top';
            }

            return '_self';
        },

        query_parameters: function(){

            if(this.isIframe){
                return '?'+this.get_partners_utm_string();
            }

            return '';
        },

    },
    methods: {

        should_display_state: function(name){

            // states to hide
            var hide = [
                'Guam',
                'Diamond Princess Cruise',
                'Wuhan Repatriated',
                'United States Virgin Islands',
                'Northern Mariana Islands',  
            ];

            return hide.map(function(x) {return x;}).indexOf(name) === -1;
        },

        clone : function(obj) {
            return JSON.parse(JSON.stringify(obj));
        },

        full_table_colspan : function() {
            return this.wide ? 11 : 8;
        },

        footer_alt : function(offset) {

            var item_count = this.limit;
            if(item_count == 0) {
                item_count = this.table_data.state_data.length;
            }
            item_count += offset;
            if( (item_count == 0 || item_count % 2) == 0 ) {
                return false;
            } else {
                return true;
            }
        },

        current_sort : function(sort_str) {

            if(this.sort_col == sort_str) {
                return this.sort_type;
            } else {
                return '';
            }
        },

        table_sort : function(sort_str, data_type) {

            if(typeof data_type === 'undefined') {
                data_type = 'number';
            }

            if(this.sort_col == sort_str) {
                if(this.sort_type == 'desc') {
                    this.sort_type = 'asc';
                } else {
                    this.sort_type = 'desc';
                }
            } else {
                this.sort_type = 'desc';
            }

            this.sort_col = sort_str;

            this.table_data.state_data.sort(function(a, b) {
                var first = a;
                var second = b;
                if(this.sort_type == 'asc') {
                    first = b;
                    second = a;
                }

                if(data_type == 'string') {
                    return first[this.sort_col].localeCompare(second[this.sort_col]);
                } else {
                    return first[this.sort_col] < second[this.sort_col] ? 1 : -1;
                }
            }.bind(this));
        },

        load_json : function() {

            this.promises.push(axios({
                method: 'get',
                url: '/json/covid/usa_states.json?cache_bust='+this.cache_bust
            }));

            axios.all(this.promises)
            .catch(function(error) {
                console.log(error);
            })
            .then(function(results) {

                results.forEach(function(r, i_r) {

                    this.load_totals(r);

                }.bind(this));
            }.bind(this));
        },

        load_totals : function(r) {

            this.table_data = r.data;

            // filter to whitelist if whitelist applied
            if(this.whitelist.length > 0) {

                var wl_states = this.table_data.state_data.filter(function(state, index) {
                    return this.whitelist.indexOf(state.name) > -1;
                }.bind(this));
                this.table_data.state_data = wl_states;
            }

            // add states to find country totals
            this.table_data.country_total = {
            confirmed_total : 0,
            deaths_total : 0,
            critical_total : 0,
            population : 0,
            };
            this.table_data.state_data.forEach(function(state) {

            this.table_data.country_total.confirmed_total += state.confirmed;
            this.table_data.country_total.population += state.population;
            this.table_data.country_total.deaths_total += state.deaths;
            this.table_data.country_total.critical_total += state.critical;
            }.bind(this));

            // filter to limit if limit applied
            // Removed to make limit just on what's shown, to improve sorting logic on HP widget 
            /*if(this.limit > 0) {

                var limit_states = this.table_data.state_data
                .sort(function(a, b){
                    return (b.deaths/b.population) - (a.deaths/a.population);
                });

                limit_states = limit_states.filter(function(state, s_index) {
                    if(s_index < this.limit){
                        return state;
                    }
                }.bind(this));

                this.table_data.state_data = limit_states;
            }*/

            // Only show row if one death or higher
            /*var death_states = this.table_data.state_data.filter(function(state) {
                return state.deaths >= 1;
            }.bind(this));
            this.table_data.state_data = death_states;*/

            // add some custom calculations in data
            this.table_data.state_data.forEach(function(state){

                state.deaths_p_cases  = (state.deaths / state.confirmed) * 100;

                if( state.population !== null ){

                    state.confirmed_pm = Math.round((state.confirmed / state.population) * 1000000);
                    state.deaths_pm    = Math.round((state.deaths / state.population) * 1000000);
                    state.recovered_pm = Math.round((state.recovered / state.population) * 1000000);
                    state.critical_pm  = Math.round((state.critical / state.population) * 1000000);
                    state.tests_pm     = Math.round((state.tests / state.population) * 1000000);

                    state.confirmed_p = (state.confirmed / state.population) * 100;
                    state.deaths_p    = (state.deaths / state.population) * 100;
                    state.recovered_p = (state.recovered / state.population) * 100;
                    state.critical_p  = (state.critical / state.population) * 100;
                    state.tests_p     = (state.tests / state.population) * 100;
                
                } else {

                    state.confirmed_pm = 0;
                    state.deaths_pm    = 0;
                    state.recovered_pm = 0;
                    state.critical_pm  = 0;
                    state.tests_pm     = 0;

                    state.confirmed_p = 0;
                    state.deaths_p    = 0;
                    state.recovered_p = 0;
                    state.critical_p  = 0;
                    state.tests_p     = 0;
                }

                // Differentiate between 0 for critical, and no critical supplied
                if(state.critical == null) {

                    state.critical_pm = null;
                    state.critical_p  = null;
                }

                if(state.tests == null) {

                    state.tests_pm = null;
                    state.tests_p  = null;
                }

                // Filter state names
                if( typeof this.alt_state_names[state.name] !== 'undefined' ) {
                    state.name = this.alt_state_names[state.name];
                }
            }.bind(this));

            // calculate global numbers

            this.table_data.country_total.confirmed_pm   = (this.table_data.country_total.confirmed_total / this.table_data.country_total.population_total) * 1000000;
            this.table_data.country_total.deaths_pm      = (this.table_data.country_total.deaths_total / this.table_data.country_total.population_total) * 1000000;
            this.table_data.country_total.critical_pm   = (this.table_data.country_total.critical_total / this.table_data.country_total.population_total) * 1000000;
            this.table_data.country_total.deaths_p_cases = (this.table_data.country_total.deaths_total / this.table_data.country_total.confirmed_total) * 100;

            // default sort by deaths per million
            this.table_sort('deaths_pm');

            this.loading = false;
        },
    },
}
</script>